import { PageController } from '@client/components/_core/layout/PageController';
import { TimelineMilestoneOverlay } from '@client/components/_core/settings/timeline/TimelineMilestoneOverlay';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/compliance/incidents/general/timeline/milestones/add',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New milestone',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <TimelineMilestoneOverlay entity="incident" />
        </PageController>
    );
}
